// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xvrl7","hasIcon":"styles_hasIcon__fBsbe","tierIcon":"styles_tierIcon__wyIH3","large":"styles_large__MXdc7"};